import { expand } from 'uri-template-lite';

import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { InputDataAction } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';

const postInputDataAction = (action: InputDataAction) =>
  apiClient
    .post(expand(InputDataUrl.INPUT_DATA_ACTION, { ...action }))
    .then((response) => response.data);

export const useInputDataActionMutation = createApiMutationHook(
  ['inputDataActionMutation'],
  getMutationFn(postInputDataAction)
);
